import React from "react";
import Ornament from "./Ornament";

export default function About({ description, cv_file }) {
  return (
    <section
      id="about"
      className="font-poppins relative bg-[#0F2419] text-[#F1E9D8] px-6 md:px-10 py-32 overflow-hidden grain"
    >
      <div className="pointer-events-none absolute top-0 right-0 w-[26rem] h-[26rem] rounded-full bg-[#D4AF6A] opacity-[0.06] blur-[120px]" />

      <div className="max-w-2xl mx-auto relative flex flex-col items-center text-center">
        <div className="flex items-center justify-center gap-4 mb-10">
          <span className="text-sm text-[#D4AF6A]">01</span>
          <span className="w-10 h-px bg-[#D4AF6A]/40" />
          <h2 className="font-display text-4xl md:text-5xl font-light">
            About
          </h2>
          <span className="w-10 h-px bg-[#D4AF6A]/40" />
          <span className="text-sm text-[#D4AF6A]">01</span>
        </div>

        <svg
          className="w-8 h-8 text-[#D4AF6A]/50 mb-6"
          viewBox="0 0 44 34"
          fill="currentColor"
        >
          <path d="M0 34V17.5C0 7.835 7.835 0 17.5 0v6.8C11.65 6.8 6.8 11.65 6.8 17.5H17.5V34H0ZM26.5 34V17.5C26.5 7.835 34.335 0 44 0v6.8c-5.85 0-10.7 4.85-10.7 10.7H44V34H26.5Z" />
        </svg>

        <p className="font-lora text-lg md:text-xl leading-relaxed text-[#EDE6D6] mb-10 text-justify w-full">
          {description}
        </p>

        <a
          href={process.env.REACT_APP_MEDIA_URL + cv_file}
          target="_blank"
          rel="noopener noreferrer"
          className="group inline-flex items-center gap-3 text-sm text-[#D4AF6A] uppercase tracking-wider"
        >
          <span className="relative">
            Download Resume
            <span className="absolute left-0 -bottom-1 w-full h-px bg-[#D4AF6A] scale-x-100 group-hover:scale-x-0 transition-transform duration-300 origin-right" />
          </span>
          <svg
            className="w-3.5 h-3.5 transition-transform group-hover:translate-y-0.5"
            viewBox="0 0 16 16"
            fill="none"
          >
            <path
              d="M8 1v10M4 8l4 4 4-4M2 15h12"
              stroke="#D4AF6A"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </a>

        <Ornament variant="divider" className="mt-16 opacity-70" />
      </div>
    </section>
  );
}
